import $ from 'jquery';
import branchBar from './modules/branch-bar';

import LoginRegister from './modules/login-register';
import FocusOutlineDetect from './modules/focus-outline-detect';
import FormHelpers from './modules/form-helpers';
import AutoExpandTextareas from './modules/auto-expand-textareas';
import ExpandingBox from './modules/expanding-box';
import TabularData from './modules/tabular-data';
import FormHelper from './modules/form-helper';
import CommentsHelper from './modules/comments-helper';
import ModalHelper from './modules/modal-helpers';
import ImageManager from './modules/image-manager';
import SearchOnPage from './modules/search-on-page';
import HideShowElements from './modules/hide-show-elements';
import Uploader from './modules/uploader';

import ItemListing from './views/item-listing';
import ItemView from './views/item-view';
import ItemViewWarehouse from './views/item-view-warehouse';
import EditMediaModal from './views/edit-media-modal';
import EditExpensesModal from './views/edit-expenses-modal';
import DeliveryView from './views/delivery-view';
import OrderDelivery from './views/order-delivery';
import EditUser from './views/edit-user';
import RefundsView from './views/refunds';
import { ArchiveModal as PreStorageEventArchiveModal, PreStorageEventView } from './views/pre-storage-events';
import ImageEditor from './views/image-editor';

import Glide from '@glidejs/glide';
import Svg4everybody from 'svg4everybody'; // for <use xlink:href> support within IE

import DateInputs from './modules/date-inputs';

import DamageMap from './modules/damage-map';
import AdditionalInfo from './modules/additional-info';

import Autofill from './modules/autofill';
import Prefill from './modules/prefill';
import ItemsSearch from './modules/items-search';
import CompareCabasItems from './views/compare-cabasitems';
import WebshopUsers from './api/webshop-users';
import CSVReportForm from './views/csv-report-form';

import Tooltip from './modules/tooltip';

import './modules/polyfills';

// Bootstrap (v3) doesn't have proper module support, so we need to make jQuery global and `require` bootstrap
global.$ = global.jQuery = $;
require('bootstrap');

//Initialize everything on document ready
$(document).ready(() => {
  branchBar.init();
  Svg4everybody();

  new FocusOutlineDetect().init();
  new AutoExpandTextareas().init();
  new ExpandingBox().init();
  new HideShowElements().init();

  new ItemListing();
  new TabularData().init();

  // Edit Expenses view functionality
  new EditExpensesModal().init();

  new PreStorageEventArchiveModal().init();
  new PreStorageEventView().init();

  new FormHelpers().init();
  new ModalHelper().init();
  new CommentsHelper().init();
  new ImageManager().init();
  new SearchOnPage().init();
  new Uploader().init();

  new Autofill({
    inputSelector: 'input.date-picker__input:not([readonly])',
    fillFunction: (event) => {
      let input = event.delegateTarget;
      if(input.previousElementSibling._flatpickr) {
        input = input.previousElementSibling;
        input._flatpickr.setDate(Date.now());
      } else {
        input.value = new Date().toLocaleDateString('fi-FI', {month: '2-digit', day: '2-digit', year: 'numeric'});
      }
      return input;
    }
  }).init();

  new Prefill().init();

  if (document.querySelector('.page--login')) {
    new LoginRegister();
  }

  if(document.querySelector('.glide__slides img:not([src=""])')) {
    new Glide('.glide', {
      animationDuration: 300,
      animationTimingFunc: 'cubic-bezier(0.125, 0.5, 0.25, 1)',
      type: 'carousel', // [carousel|slider]
      startAt: 0,
      perView: 1,
      gap: 0,
      peek: 0
    }).mount();
  }

  new DateInputs().init();

  new FormHelper().init();

  // If in item view, initialize functionality for that
  if (typeof window.ITEM_ID !== 'undefined') {
    new ItemView(window.ITEM_ID).init();
    new ItemViewWarehouse(window.ITEM_ID).init();
  }

  // If in item view, initialize functionality for that
  if (typeof window.DELIVERY_ID !== 'undefined') {
    new DeliveryView(window.DELIVERY_ID).init();
  }

  new OrderDelivery().init();

  new EditUser();

  new RefundsView().init();


  if(document.querySelector('.js-damage-map-choose-all')) {
    new DamageMap().init();
  }

  if(document.querySelector('.tooltip')) {
    new Tooltip().init();
  }

  // SVTWS-707: additional information field
  if(document.querySelector('#additional_information')) {
    new AdditionalInfo().init();
  }

  // Edit Media view functionality
  const editMediaModal = new EditMediaModal({ 
    allMediaItemIds: Array.from(document.querySelectorAll('.image-grid__item'), item => item.getAttribute('data-item-id')),
  });
  editMediaModal.init();

  new ImageEditor({
    editMediaModal
  }).init();

  new ItemsSearch().init();

  // Webshop users search
  new ItemsSearch({
    selectorForm: 'form[data-action="webshop-users-search"]',
    selectorInput: '#webshopUsersSearchInput',
    selectorClear: '#webshopUsersSearchClear',
    selectorOutput: '#webshopUsersSearchOutput',
    templateResults: 'WebshopUsersSearchResults',
    searchMethod: WebshopUsers.search.bind(WebshopUsers)
  }).init();

  new CompareCabasItems();

  new CSVReportForm().init();
});
